import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

const ORDER_TTL_MS = 5 * 60 * 1000;

interface StoredOrderId {
  id: string;
  lastUpdate: number;
}

export function getStoredOrderId(): string | undefined {
  const stored = syncStorage.getObject<StoredOrderId>(SyncStorageKey.ORDER_ID);

  if (!stored) {
    return;
  }

  if (stored.lastUpdate < Date.now() - ORDER_TTL_MS) {
    syncStorage.remove(SyncStorageKey.ORDER_ID);
    return;
  }

  return stored.id;
}

export function isRbiOrderValid(rbiOrderId: string | null): boolean {
  const now = Date.now();
  const stored = syncStorage.getObject<StoredOrderId>(SyncStorageKey.ORDER_ID);

  if (!rbiOrderId && !stored) {
    return false;
  }

  if (!rbiOrderId && stored) {
    if (stored.lastUpdate < now - ORDER_TTL_MS) {
      syncStorage.remove(SyncStorageKey.ORDER_ID);
      return false;
    }

    return true;
  }

  if (rbiOrderId && !stored) {
    syncStorage.setObject(SyncStorageKey.ORDER_ID, { id: rbiOrderId, lastUpdate: now });
    return true;
  }

  if (rbiOrderId && stored) {
    if (stored.id !== rbiOrderId) {
      syncStorage.setObject(SyncStorageKey.ORDER_ID, { id: rbiOrderId, lastUpdate: now });
      return true;
    }

    if (stored.lastUpdate < now - ORDER_TTL_MS) {
      syncStorage.remove(SyncStorageKey.ORDER_ID);
      return false;
    }

    return true;
  }

  return false;
}
